import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Container, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { handleMicrosoftRedirect } from '../auth/azureAuth';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { loginWithSsoIdToken } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      try {
        const result = await handleMicrosoftRedirect();
        const idToken = result?.idToken;

        if (!idToken) {
          throw new Error('Nao foi possivel obter o token de autenticacao da Microsoft.');
        }

        await loginWithSsoIdToken(idToken);
        navigate('/dashboard', { replace: true });
      } catch (err: any) {
        console.error('SSO callback error:', err);
        if (mounted) {
          const backendDetail = err?.response?.data?.detail;
          const message =
            (typeof backendDetail === 'string' && backendDetail) ||
            err?.message ||
            'Falha ao concluir login SSO.';
          setError(message);
        }
      }
    };

    run();
    return () => {
      mounted = false;
    };
  }, [loginWithSsoIdToken, navigate]);

  return (
    <Container className="login-container">
      <Card className="login-card">
        <Card.Body className="text-center">
          <h5 className="mb-3">Concluindo login com Microsoft...</h5>
          {!error && <Spinner animation="border" role="status" />}
          {error && (
            <>
              <Alert variant="danger" className="mt-3">
                {error}
              </Alert>
              <Button variant="primary" onClick={() => navigate('/login', { replace: true })}>
                Voltar ao login
              </Button>
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AuthCallback;
